import {
  BundleCloseButton,
  BundleContainer,
  BundleContent,
  BundleCopy,
  BundleFooter,
  BundleHero,
  BundleIncluded,
  BundleLoading,
  BundleProductCard,
  BundleSelectedItem,
  BundleSelectList,
  BundleSelectModal,
  BundleSlot,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Bundle = {
  CloseButton: BundleCloseButton,
  Container: BundleContainer,
  Content: BundleContent,
  Copy: BundleCopy,
  Footer: BundleFooter,
  Hero: BundleHero,
  Included: BundleIncluded,
  Loading: BundleLoading,
  ProductCard: BundleProductCard,
  SelectList: BundleSelectList,
  SelectModal: BundleSelectModal,
  SelectedItem: BundleSelectedItem,
  Slot: BundleSlot,
};
